import RequestBuilder from '../Lib/Requests';

export default class AlertService {
  api = new RequestBuilder();

  buildAlertByRuleMetricsRequest(params, cancelToken) {
    return {
      cancelToken,
      endpoint: '/v1/metrics/alerts',
      method: 'get',
      params,
      service: 'rules',
    };
  }

  async fetchAlertByRuleMetrics(params, cancelToken) {
    const { data } = await this.api.request(
      this.buildAlertByRuleMetricsRequest(params, cancelToken)
    );
    return data;
  }

  buildAlertsByRuleRequest(params, cancelToken) {
    return {
      service: 'rules',
      endpoint: '/v1/alerts',
      method: 'get',
      params,
      cancelToken,
    };
  }

  async fetchPaginatedAlertsByRule(params, cancelToken) {
    const { data } = await this.api.request(
      this.buildAlertsByRuleRequest(params, cancelToken)
    );
    return data;
  }

  buildClearAlertRequest({ alertID, ...params }, cancelToken) {
    return {
      service: 'rules',
      endpoint: `/v1/alerts/${alertID}/clear`,
      method: 'put',
      params,
      cancelToken,
    };
  }

  async clearAlert(params, cancelToken) {
    const { data } = await this.api.request(
      this.buildClearAlertRequest(params, cancelToken)
    );
    return data;
  }
}
